<div class="confirm">
    <div class="title-row">
        <h2 class="title" [class.danger]="data.danger">{{ data.title }}</h2>
        <button
            type="button"
            class="icon-close close"
            aria-label="Close"
            (click)="cancel()"
        ></button>
    </div>
    <p class="message">
        @for (segment of messageSegments; track $index) {
            @if (segment.bold) {
                <strong>{{ segment.text }}</strong>
            } @else {
                <!-- ng-container keeps the interpolation the sole content of its node, so the
                     template's own indentation isn't collapsed into a stray space between runs. -->
                <ng-container>{{ segment.text }}</ng-container>
            }
        }
    </p>

    <div class="cta">
        <tools-button [variant]="buttonVariant.OUTLINE" (onClick)="cancel()">
            {{ data.cancelLabel ?? "Cancel" }}
        </tools-button>
        <tools-button (onClick)="confirm()">
            {{ data.confirmLabel }}
        </tools-button>
    </div>
</div>
